import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Divider,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { AccordionArrowPurple, AccordionArrowPurpleClose } from 'Images';
import { FC, useEffect, useState } from 'react';

interface IAccordionSection {
  title: string;
  subtitle?: string;
  defaultExpanded?: boolean;
  summaryStyle?: SxProps;
  detailsStyle?: SxProps;
}

export const AccordionSection: FC<IAccordionSection> = (props) => {
  const isDesktop = useIsDesktop();

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (props.defaultExpanded) setIsExpanded(true);
  }, [props.defaultExpanded]);

  const handleAccordionChange = (
    event: React.SyntheticEvent,
    expanded: boolean
  ) => {
    setIsExpanded(expanded);
  };

  return (
    <Accordion
      expanded={isExpanded}
      onChange={handleAccordionChange}
      sx={{
        width: '100%',
        borderRadius: '16px !important',
        boxShadow: '-2px -2px 12px 0px rgba(8, 30, 84, 0.04)',
        overflow: 'hidden',
        '&::before': { display: 'none' },
        minWidth: isDesktop ? '400px' : undefined,
        '.MuiAccordionSummary-content': {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        sx={{
          padding: isDesktop ? '24px' : '16px',
          paddingBottom: isDesktop ? '12px' : '16px',
          ...props.summaryStyle,
        }}
        expandIcon={
          <>
            {!isExpanded && (
              <Avatar
                src={AccordionArrowPurple}
                sx={{
                  width: '32px',
                  height: '32px',
                }}
              />
            )}
            {isExpanded && (
              <Avatar
                src={AccordionArrowPurpleClose}
                sx={{
                  width: '32px',
                  height: '32px',
                  rotate: '180deg',
                }}
              />
            )}
          </>
        }
      >
        <Stack>
          <Typography variant={'body1'} tabIndex={0}>
            {props.title}
          </Typography>
          <Typography variant={'body6'} tabIndex={0}>
            {props.subtitle}
          </Typography>
          {isDesktop && (
            <Box
              width={'153px'}
              height={'153px'}
              borderRadius={'50%'}
              position={'absolute'}
              top={'-50px'}
              right={'-8%'}
              bgcolor={'purple2.shade_100'}
              sx={{
                opacity: '.7',
              }}
            ></Box>
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: isDesktop ? '0px 24px 56px 24px' : '0px 16px 24px 16px',
          display: 'flex',
          flexFlow: 'column',
          ...props.detailsStyle,
        }}
      >
        <Divider
          aria-hidden='true'
          orientation={'horizontal'}
          sx={{
            borderColor: 'primary.shade_100',
            maxWidth: isDesktop ? '626px' : 'initial',
            marginBottom: isDesktop ? '32px' : '16px',
          }}
        />
        {props.children}
      </AccordionDetails>
    </Accordion>
  );
};
